import { TextField } from 'mui-rff';
import React from 'react';

import { Link, Stack } from '@mui/material';

import FromTemplateInput from './FromTemplateInput';

type Props = {
  name: string;
};
export default function SendMarkdownEmailMessageForm({ name }: Props) {
  return (
    <Stack spacing={2} pt={2}>
      <FromTemplateInput name={name} />
      <TextField
        size="small"
        name={`${name}.sendMarkdownEmailMessage.toTemplate`}
        label="To"
        placeholder="{{user.email}}"
      />
      <TextField size="small" name={`${name}.sendMarkdownEmailMessage.ccTemplate`} label="cc" />
      <TextField size="small" name={`${name}.sendMarkdownEmailMessage.bccTemplate`} label="bcc" />
      <TextField
        size="small"
        name={`${name}.sendMarkdownEmailMessage.subjectTemplate`}
        label="Subject"
        placeholder="Can we help?"
      />
      <TextField
        label="Your message"
        helperText={
          <>
            <Link
              color="inherit"
              underline="hover"
              fontWeight="fontWeightMedium"
              target="_blank"
              href="https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax"
            >
              GitHub Flavored Markdown
            </Link>{' '}
            and{' '}
            <Link
              color="inherit"
              underline="hover"
              fontWeight="fontWeightMedium"
              target="_blank"
              href="https://liquidjs.com/tutorials/intro-to-liquid.html"
            >
              Liquid templating
            </Link>{' '}
            supported
          </>
        }
        multiline
        minRows={3}
        name={`${name}.sendMarkdownEmailMessage.messageTemplate`}
        placeholder="Hi {{user.name}}!"
      />
    </Stack>
  );
}
